import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {api} from "../../maps/data";
import {FormGroup} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";

const WrapperStyled = styled.div`
    width: 620px;
    margin-top: 67px;
`;

const WrapperInsideStyled = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 60px;
    padding: 10px 20px;
`;

const EditStyled = styled.div`
    margin-top: 130px;
    padding: 10px 20px;
`;

const SiteLabelStyled = styled.div`
    margin: 4px 0;
    color: ${colors.LIGHT_GRAY};
    font-size: 13px;
`;

const InputWrapperStyled = styled.div`
    margin: 15px 0;

    textarea {
        resize: none;
        width: 100%;
        border-radius: 4px;
        padding: 15px;
    }
`;

const MainTitleStyled = styled.div`
    font-weight: 700;
    line-height: 1.55556;
    font-size: 1.2625rem;
    font-family: "Public Sans", sans-serif;
    border-width: 0 0 thin;
    border-style: solid;
    border-color: rgba(145, 158, 171, 0.2);
    text-align: center;
    padding: 11px 0;
`;

const ItemImageStyled = styled.div`
    width: 100%;
    height: 200px;

    img {
        width: 100%;
        height: 320px;
        object-fit: cover;
        max-width: 200px;
    }
`;

const ItemInfoStyled = styled.div`
    padding: 10px;

    span {
        font-size: 21px;
    }

    .product-info-label {
        color: ${colors.LIGHT_GRAY};
        font-size: 17px;
        margin-right: 3px;
    }

    //.name{
    //    display: inline-block;
    //}

    .pika-name {
        display: inline-block;
        font-size: 14px;
        padding: 0 6px 13px;
        margin: 0;
        direction: ltr;
        text-align: left;
        width: 144px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: text-top;
    }

    &.rtl {
        direction: rtl;
        text-align: right;
    }
`;

const ProductInventoryEdit = ({item, close, site}) => {
    const [totalOnSite, s_totalOnSite] = useState(0);
    const [threshold, s_threshold] = useState(0);
    const [reason, s_reason] = useState("");
    const [thresholdChanged, s_thresholdChanged] = useState(false);
    const [sigma, s_sigma] = useState(false);
    const [sigmaError, s_sigmaError] = useState("");

    let thresholdData = 50;
    let fromSite = true;
    if (item?.inventory?.[0]?.alertSettings?.low_inventory?.threshold) {
        fromSite = false;
        thresholdData = item.inventory[0].alertSettings.low_inventory.threshold;
    } else {
        thresholdData = site?.alertSettings?.low_inventory?.threshold || 50;
    }
    let inventory = {
        quantity: 0,
        isWatching: false
    };
    if (item?.inventory?.length) {
        inventory = item?.inventory[0];
    }

    useEffect(() => {
        s_totalOnSite(inventory.quantity);
        s_threshold(thresholdData);
        s_sigma(!!inventory.isWatching);
    }, []);

    const save = async () => {
        const data = {
            productId: item.productId,
            quantity: Number(totalOnSite),
            reason
        };

        if (thresholdChanged) {
            data.alertSettings = {
                low_inventory: {
                    isEnabled: true,
                    sev: "CRITICAL",
                    threshold: Number(threshold)
                }
            };
        }

        await api({
            type: "setProductInventory",
            data: data
        });
        s_reason("");
        close();
    };

    const sigmaHandle = async (isWatching) => {
        try {
            const resp = await api({
                type: "setSigmaBusketInventory",
                data: {
                    productId: item.productId,
                    isWatching: isWatching
                }
            });

            if (!resp.isOk) {
                if (resp.reason === "MAX") {
                    s_sigmaError(`Maximum products limit of ${resp.max}, please remove other products from Sigma to add new one`);
                }
                s_sigma(false);
            }
        } catch (e) {
            console.log("d");
        }
    };

    const editDisabled = !!!reason;

    const onShelf = item?.placementCount || 0;
    const onSite = inventory.quantity;
    const total = onShelf + onSite;

    return (
        <WrapperStyled>
            <MainTitleStyled>{item.name}</MainTitleStyled>
            <WrapperInsideStyled>
                <ItemImageStyled>
                    <img src={item.imageUrl} alt=""/>
                </ItemImageStyled>

                <ItemInfoStyled>
                    <div>
                        <span className="product-info-label">SKU:</span>
                        <span>{item.sku}</span>
                    </div>
                    <div>
                        <span className="product-info-label">Barcode:</span>
                        <span>{item.barcode}</span>
                    </div>
                    <div>
                        <span className="product-info-label">On Shelves:</span>
                        <span>{onShelf}</span>
                    </div>
                    <div>
                        <span className="product-info-label">On Site:</span>
                        <span>{onSite}</span>
                    </div>
                    <div>
                        <span className="product-info-label">Total:</span>
                        <span>{total}</span>
                    </div>
                </ItemInfoStyled>
            </WrapperInsideStyled>
            <EditStyled>
                <InputWrapperStyled>
                    <TextField
                        sx={{width: '150px'}}
                        value={totalOnSite}
                        onChange={(e) => {
                            s_totalOnSite(e.target.value);
                        }}
                        type="number"
                        id="outlined-basic" label="Quantity Site" variant="outlined" size="small"
                    />
                </InputWrapperStyled>

                <InputWrapperStyled>
                    {fromSite && (
                        <SiteLabelStyled>Settings from Site</SiteLabelStyled>
                    )}
                    <TextField
                        sx={{width: '150px'}}
                        value={threshold}
                        onChange={(e) => {
                            s_threshold(e.target.value);
                            s_thresholdChanged(true);
                        }}
                        type="number"
                        id="outlined-basic" label="Threshold %" variant="outlined" size="small"
                    />
                </InputWrapperStyled>

                <InputWrapperStyled>
                        <textarea
                            placeholder="Reason"
                            rows="5"
                            value={reason}
                            onChange={(e) => {
                                s_reason(e.target.value);
                            }}
                        />
                </InputWrapperStyled>
                <InputWrapperStyled>
                    <Button
                        onClick={save}
                        disabled={editDisabled} variant="contained">Edit</Button>
                </InputWrapperStyled>

                <Divider flexItem/>

                <InputWrapperStyled>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch checked={sigma} onChange={() => {
                                    s_sigma(!sigma);
                                    sigmaHandle(!sigma);
                                }}/>
                            }
                            label="Watching in Sigma Busket"
                        />
                    </FormGroup>
                    {sigmaError && (
                        <div style={{color: colors.RED1}}>
                            {sigmaError}
                        </div>
                    )}
                </InputWrapperStyled>
            </EditStyled>
        </WrapperStyled>
    );
};

export default ProductInventoryEdit;